import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'
import { IApproval, ICompliance, ISailPointCertDetails } from '@/types/tasksApprovals'

import CoApprovers from './components/coApprovers'
import SailpointCertGroups from './components/groups'

const Container = ({ item, itemDetails }: { item: ICompliance | IApproval; itemDetails: ISailPointCertDetails[] }) => {
    const approvals = Number(item.metadata?.counter?.split('/')[1] ?? 0)

    const { t } = useTranslation()

    return (
        <>
            <CoApprovers ratifiers={item.ratifiers ?? []} />
            {approvals > 999 && (
                <Box px="24px">
                    <Text mt="24px" mb="16px">
                        {t('tasksApprovals.sailPointCertDrawer.body.over_999.line_1')}
                    </Text>
                    <Link href={item.action_source_system_parent_url ?? ''} textDecoration="underline" isExternal>
                        {t('tasksApprovals.sailPointCertDrawer.body.over_999.line_2')}
                    </Link>
                </Box>
            )}
            {approvals <= 999 && <SailpointCertGroups item={itemDetails} />}
        </>
    )
}

export default Container
